import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section id="precio" className="bg-[#1B2A4A] text-[#F5F0E8] py-24 px-4" data-id="element-24">
      <div className="max-w-2xl mx-auto text-center" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-26">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-8" data-id="element-27">
            La pregunta real
          </h2>

          <div className="prose prose-lg prose-invert mx-auto mb-12" data-id="element-28">
            <p className="text-xl md:text-2xl opacity-90" data-id="element-29">
              No es: "¿puedo comprar esto?"
            </p>
            <p className="text-xl md:text-2xl font-bold text-[#C94040]" data-id="element-30">
              La pregunta es: ¿cuánto te cuesta seguir improvisando cada mes?
            </p>
            <div className="text-left bg-white/5 p-8 rounded-xl my-8 space-y-4" data-id="element-31">
              <p data-id="element-32">• Un cargo por atraso.</p>
              <p data-id="element-33">• Una compra sin lista.</p>
              <p data-id="element-34">• Una medicina pagada sin preguntar.</p>
              <p data-id="element-35">• Una suscripción olvidada.</p>
              <p className="font-bold text-xl pt-4 border-t border-white/10" data-id="element-36">
                Eso se come el mes.
              </p>
            </div>
          </div>

          {/* Modified section starts here */}
          <div id="precio" className="bg-[#F5F0E8] text-[#1B2A4A] p-8 md:p-12 rounded-2xl mb-12" data-id="element-37">
            <h3 className="text-2xl font-bold mb-4" data-id="element-38">
              Si quieres un sistema claro, sin apps, sin regaños y con pasos
              pequeños:
            </h3>
            <p className="text-xl mb-8" data-id="element-39">
              Descarga "$56 Más No Te Salva" hoy y empieza el Día 1 en menos de
              15 minutos.
            </p>
            <div className="mb-8" data-id="element-40">
              <span className="text-lg text-gray-500 line-through mr-3" data-id="element-41">
                $19.99
              </span>
              <span className="text-4xl md:text-5xl font-bold text-[#C94040]" data-id="element-42">
                $6.39
              </span>
              <span className="block text-sm text-gray-500 mt-1" data-id="element-43">
                Precio especial por tiempo limitado
              </span>
            </div>
            <CTAButton fullWidth href="https://claridaddiaria.com/cart/43001270403138:1" data-id="element-44">
              QUIERO EL PLAN DE 14 DÍAS
            </CTAButton>
          </div>
          <p className="text-sm opacity-60 mt-8" data-id="element-45">
            Pago seguro • Descarga inmediata • Garantía de satisfacción
          </p>
        </motion.div>
      </div>
    </section>;
}